import axios from "axios";

//1/ ============================================================
//1/ عنوان الـ API:
//1/ - لو عرّفت REACT_APP_API_URL في .env.development يُستخدم كما هو.
//1/ - لو فاضي: يُبنى من نفس hostname المتصفح (localhost أو 127.0.0.1) + المنفذ 8000
//1/   عشان مايحصلش Network Error لما تفتح الواجهة من 127.0.0.1:3001 والـ API على localhost.
//1/ شغّل Laravel: php artisan serve --host=0.0.0.0 --port=8000
//1/ ============================================================
function resolveApiBase() {
  const fromEnv = (process.env.REACT_APP_API_URL || "").trim().replace(/\/+$/, "");
  if (fromEnv) {
    return fromEnv;
  }
  return "https://backend.nouhacadeemy.com/api";
}

export const baseURL = resolveApiBase();

export const REGISTER      = "auth/register";
export const LOGIN         = "auth/login";
export const LOGOUT        = "auth/logout";
export const FORGETPASSWORD= "auth/forgot-password";
export const RESETPASSWORD = "auth/reset-password";
export const DATAUSER      = "auth/me";
export const REFRESH_URL   = "auth/token/refresh";

export const USERACADEMACSTATUSE  = "learning/user-academic-stats";
export const ACADEMACYEARSDASHBORD= "learning/academic-years-dashboard";
export const DELETACASEC          = "learning/delete-academic-year";
export const ADD                  = "learning/insert-academic-year";
export const UPDATE               = "learning/academic-edit-data";
export const EDITTACADEMAC        = "learning/edit-academic-year";
export const ACADEMICTYPE         = "learning/academic/type";
export const ACADIMAC             = "learning/academics";

export const ACADEMICYEARID = "learning/chapters";
export const STYDYMONTH     = "learning/chapter-dashboard";
export const ADDMONTH       = "learning/insert-chapter";
export const DELETEMONTY    = "learning/delete-chapter";
export const UPDATETMONTH   = "learning/chapter-edit-data";
export const EDITMONTH      = "learning/edit-chapter";

export const CHAPTERID      = "learning/lessons";
export const VIDIO          = "learning/lesson_detail";
export const LESSONSDASHBORD= "learning/lesson-dashboard";
export const DELETELESSONS  = "learning/delete-lesson";
export const ADDLESSON      = "learning/insert-lesson";
export const UPDATELESSON   = "learning/lesson-edit-data";
export const EDITLESSON     = "learning/edit-lesson";
export const YEARLESSON     = "learning/year-lesson";

export const EXAM               = "learning/chapter_exam";
export const SUBMITANSWR        = "submit";
export const EXAMDASHBORD       = "learning/exam-dashboard";
export const EXAMS_BY_CHAPTER   = "exams-by-chapter";
export const DELETEEXAM         = "learning/delete-exam";
export const ADDEXAM            = "learning/insert-exam";
export const EDITEXAM           = "learning/exam-edit-data";
export const UPDATEEXAM         = "learning/edit-exam";

export const CREATEQUESTIONDASHBORD = "learning/questions-dashboard";
export const DELETEQUESTIONS        = "learning/delete-questions";
export const ADDQUESTIONS           = "learning/insert-questions";
export const EDITQUESTION           = "learning/questions-edit-data";
export const UPDATEQUESTION         = "learning/edit-question";

export const STUDENTMESSAGE  = "learning/student-messages";
export const CONTACTMASSEGE  = "learning/contact-messages";
export const SENDMESSAGE     = "learning/send-message";
export const SENDRESPONSE    = "learning/send-response";
export const RETURNRESPONSE  = "learning/return-response";
export const STUDENTQUEREY   = "learning/students-messages-dashboard";
export const DELETEMESSAGE   = "learning/delete-students-messages";
export const CONTACTMESSAGE  = "learning/contact-messages-dashboard";
export const DELETECONTACT   = "learning/delete-contact-messages";

export const USERDASHBORD = "learning/students-dashboard";
export const DELETEUSER   = "learning/delete-student";
export const PAN          = "learning/ban-student";
export const UNBAN        = "learning/unban-student";

export const PYMENT       = "payment/submit-credit-request";
export const PAYMENTMONTH = "payment/purchase-month";
export const MONEY        = "payment/credit-request-dashboard";
export const APROVE       = "payment/approve-request";
export const REJECT       = "payment/reject-request";

export const REVENUE = "learning/revenue-academic-stats";
export const LESSONS = "learning/lessons-academic-stats";
export const MONTHLY_SUMMARY = "learning/monthly-summary";

export const TASKS         = "learning/tasks";
export const TASKDHASHBORD = "learning/tasks-dashboard";
export const DELETETASK    = "learning/delete-tasks";
export const ADDTASK       = "learning/insert-tasks";
export const EDITTASK      = "learning/task-edit-data";
export const UPDATETASK    = "learning/edit-task";

export const RESENTCONTENT      = "learning/get-recent-announcement";
export const ANNOUNCEMNTS       = "learning/announcemnts-dashboard";
export const DELETEANNOUNCEMNTS = "learning/delete-announcemnts";
export const ADDANNOUNCEMNT     = "learning/insert-announcemnt";
export const EDITANNOUNCEMNT    = "learning/announcemnt-edit-data";
export const UPDATEANNOUNCEMNT  = "learning/edit-announcemnt";
export const ACTIVE_ANNOUNCEMENTS = "learning/active-announcements";
export const SETTINGS = "learning/settings";

export const axiosPrivate = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});


